//const portlessProxy = "http://3.6.19.89:2319"; // Public IP of server
// const portlessProxy = "http://13.203.75.240:2319"
const portlessProxy = "https://socket.vision-web.tech";
// const portlessProxy = "http://10.17.13.4:2319"
//const portlessProxy = "http://SocketLoadBalancer-1162640787.ap-south-1.elb.amazonaws.com"; // load-balancer
//const portlessProxy = "https://securesocketlb-67249613.ap-south-1.elb.amazonaws.com/"
module.exports = portlessProxy;
            